import React from 'react'
import { SelectChangeEvent } from '@mui/material'

import { Select } from '@/components'
import { OptionsValue } from '@/types.ts'
import { B2CRegistryStatus } from '@/@types/b2c.types.ts'
import { useB2CState } from '@/stores/slices/b2c-slice'
import { useAppDispatch } from '@/stores/hooks.ts'
import { b2cActions } from '@/stores/slices/b2c-slice/b2c-slice.ts'

const MENU_ITEMS: OptionsValue<B2CRegistryStatus | 'ALL'> = [
  { value: 'ALL', label: 'Все' },
  { value: 'WAIT_CONFIRM', label: 'Ожидает подтверждения' },
  { value: 'ACCEPTED', label: 'Принят' },
  { value: 'PROCESSING', label: 'В работе' },
  { value: 'COMPLETED', label: 'Загружен' },
  { value: 'FAILED', label: 'Ошибка загрузки' },
]

export const B2CRegistryTableStateFilter = (): React.ReactElement => {
  const { b2cRegistryState: state } = useB2CState()
  const dispatch = useAppDispatch()

  const handleStatusChange = (event: SelectChangeEvent) => {
    dispatch(
      b2cActions.setFilter({
        filterKey: 'b2cRegistryState',
        filterValue: event.target.value === 'ALL' ? '' : event.target.value,
      })
    )
  }

  const selectValue = state || 'ALL'

  return (
    <Select value={selectValue} onChange={handleStatusChange} items={MENU_ITEMS} label="Статус" labelId="sbp-status" />
  )
}
